import ".././styles/Hero.css";
import heroimage from ".././assets/hero.jpg";
import { HashLink as Link } from 'react-router-hash-link';

function Hero() {
    return(
        <div className="hero-container">
            <div className="hero-wrapper wrapper">
                <div className="hero">
                    <div className="hero-contents">
                        <h1 id="hero-primary-text">
                        The Philippine Canadian Centre of Manitoba
                        </h1>
                        <p className="body-text" id="hero-text">
                        is a non-profit organization with CRA charitable status that supports the needs of newly-arrived Filipino immigrants, 
                        and prides itself on providing a venue where Filipino culture and heritage are preserved and shared with the wider community.
                        </p>
                        <Link to="/aboutus#aboutus-top" className="button-2 button-shadow" id="hero-button">
                            Explore
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Hero;